export const RM04_04 = {
  selectedValueColumn: "DrillKey",
  selectedTitle: "Branch",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Branch",
        binding: {
          data: {
            columns: [
              {
                name: "Branch Name",
                columnName: "BranchName",
                width: "250px",
                align: "left",
                sortable: true,
                sum: false,
              },
              {
                name: "Branch Address",
                columnName: "BranchAddress",
                width: "450px",
                align: "left",
                sortable: true,
                sum: false,
              },
              {
                name: "Availability",
                columnName: "Availability",
                width: "250px",
                align: "center",
                sortable: false,
              },
            ],
            title: "BranchName",
            endpoint: "RM04.4",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "RegionCode", value: "" },
              { key: "DrillKey", value: "" },
            ],
          },
          context: {
            point: {
              onClick: {},
            },
          },
        },
      },
    },
  ],
};
